import { render, staticRenderFns } from "./PersonForm.vue?vue&type=template&id=0bed79d2"
import script from "./PersonForm.vue?vue&type=script&lang=js"
export * from "./PersonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports